import {useEffect, useRef, useState} from "react";

import {generateUUID, notifyError} from "../utils/helpers";
import classes from "./TimeLimitInputBox.module.css";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";


export default function TimeLimitInput({label, setTimeLimit, timeLimit, unit="MM:SS", minVal, reachMinValErrorText}) {
    const { t } = useTranslation();
    const [isSelectedCustom, setIsSelectedCustom] = useState(false);
    const firstInputRef = useRef();
    const secondInputRef = useRef();

    const getFormatedTimeFromSeconds = (timeLimit) => {

        if (unit === "MM:SS") {
            let minutes = Math.floor(timeLimit / 60);
            let seconds = timeLimit % 60;

            return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        } else {
            let hours = Math.floor(timeLimit / 3600);
            let minutes = Math.floor(timeLimit % 3600 / 60);

            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        }

    }


    const [firstInputVal, setFirstInputVal] = useState(() => {
        let inputVal = getFormatedTimeFromSeconds(timeLimit);
        return inputVal.split(":")[0];
    });

    const [secondInputVal, setSecondInputVal] = useState(() => {
        let inputVal = getFormatedTimeFromSeconds(timeLimit);
        return inputVal.split(":")[1];
    });






    // useEffect(() => {
    //     let inputVal = getFormatedTimeFromSeconds(timeLimit);
    //     setFirstInputVal(inputVal.split(":")[0])
    //     setSecondInputVal(inputVal.split(":")[1])
    // }, [timeLimit]);


    const changeTimeLimit = () => {
        const firstUnit = !!firstInputVal ? parseInt(firstInputVal) : 0;
        const secondUnit = !!secondInputVal ? parseInt(secondInputVal) : 0;

        let val = 0;
        if (unit === "MM:SS") {
            val = firstUnit * 60 + secondUnit;
        } else {
            val = firstUnit * 3600 + secondUnit * 60;
        }

        if (!!minVal && minVal > val) {
            notifyError(reachMinValErrorText);
            val = minVal;

            let inputVal = getFormatedTimeFromSeconds(val);
            setFirstInputVal(inputVal.split(":")[0])
            setSecondInputVal(inputVal.split(":")[1])

        }
        setTimeLimit(val);
    }


    const onChangeFirstInput = (e) => {
        let input = e.target.value;

        let result = '';
        for (let i = 0; i < input.length; i++) {
            if (result.length === 2) {
                break;
            }

            const char = input[i];
            if (/\d/.test(char)) {
                result += char;
            }
        }


        if (result.length === 2) {
            if (unit === "HH:MM") {
                result = Math.min(parseInt(result), 23).toString().padStart(2, '0');
            } else {
                result = Math.min(parseInt(result), 59).toString().padStart(2, '0');
            }
        }

        setFirstInputVal(result);
    }


    const onChangeSecondInput = (e) => {
        let input = e.target.value;



        let result = '';
        for (let i = 0; i < input.length; i++) {
            if (result.length === 2) {
                break;
            }

            const char = input[i];
            if (/\d/.test(char)) {
                result += char;
            }
        }


        if (result.length === 2) {
            result = Math.min(parseInt(result), 59).toString().padStart(2, '0');
        }

        setSecondInputVal(result);
    }


    const onBlurInput = (e, setInput) => {
        let inputVal = !!e.target.value ? e.target.value : "0";

        if (inputVal.length < 2) {
            setInput(inputVal.padStart(2, '0'));
        } else {
            setInput(inputVal);
        }
    }

    return (
        <div style={{display: "flex", flexDirection: "column"}}>
            <span className={classes.labelBox}>
                <span style={{
                    flex: 1,
                    minWidth: 0,
                    textAlign: "center",
                }}>{unit === "MM:SS" ? t("questionBuilder.minutesLabel") : t("questionBuilder.hoursLabel")}</span>
                <span style={{width: 5}}/>
                <span style={{
                    flex: 1,
                    minWidth: 0,
                    textAlign: "center",
                }}>{unit === "MM:SS" ? t("questionBuilder.secondsLabel") : t("questionBuilder.minutesLabel")}</span>
            </span>
            <div
                className={classes.inputBox}
                onBlur={(e) => {
                    if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) {
                        changeTimeLimit();
                    }
                }}
            >
                <div className={classes.inputContainer}>
                    <input
                        type={"number"}
                        min={0}
                        ref={firstInputRef}
                        value={firstInputVal}
                        onChange={onChangeFirstInput}
                        onBlur={e => onBlurInput(e, setFirstInputVal)}
                        placeholder={unit === "HH:MM" ? "HH" : "MM"}
                        aria-label={(label ? label : t("gradebook.timeLimitText")) + " " + (unit === "HH:MM" ? t("questionBuilder.hoursLabel") : t("questionBuilder.minutesLabel"))}
                    />
                </div>
                <span style={{width: 5, textAlign: "center"}}>:</span>

                <div className={classes.inputContainer}>
                    <input
                        type={"number"}
                        min={0}
                        ref={secondInputRef}
                        value={secondInputVal}
                        onChange={onChangeSecondInput}
                        onBlur={e => onBlurInput(e, setSecondInputVal)}
                        placeholder={unit === "HH:MM" ? "MM" : "SS"}
                        aria-label={(label ? label : t("gradebook.timeLimitText"))  + " " + (unit === "HH:MM" ? t("questionBuilder.minutesLabel") : t("questionBuilder.secondsLabel"))}
                    />
                </div>
            </div>
        </div>
    );
}

TimeLimitInput.propTypes = {
    timeLimit: PropTypes.number,
    setTimeLimit: PropTypes.func,
    unit: PropTypes.oneOf(["HH:MM", "MM:SS"]),

}